"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncUrlParams = void 0;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const app_1 = require("app");
const SearchResultUrlService_1 = require("../../services/SearchResultUrlService");
const constants_1 = require("../../constants");
const useSyncUrlParams = (selectedTab, isDocumentPage) => {
    const typeFilterUrlKey = isDocumentPage ? constants_1.DOCUMENT_TYPE_KEY : constants_1.TAB_KEY;
    const { uiState } = (0, react_instantsearch_1.useInstantSearch)();
    const selectedTabKey = selectedTab.key;
    const selectedTabIndexName = selectedTab.indexName;
    const previousStateRef = React.useRef('');
    React.useEffect(() => {
        // Removing deprecated 'filter' param from URL if exists
        app_1.UrlService.RemoveFromUrl('filter');
    }, []);
    React.useEffect(() => {
        const state = uiState[selectedTabIndexName];
        if (!state) {
            return;
        }
        const stateSnapshot = JSON.stringify({ selectedTabKey, state });
        if (previousStateRef.current === stateSnapshot) {
            return;
        }
        previousStateRef.current = stateSnapshot;
        SearchResultUrlService_1.searchResultUrlService.syncToUrl({
            query: state.query,
            page: state.page,
            hitsPerPage: state.hitsPerPage,
            tabKey: selectedTabKey,
            tabUrlKey: typeFilterUrlKey,
            tabFilterPrefix: selectedTabKey,
            refinementList: state.refinementList || {},
            menu: state.menu || {},
            hierarchicalMenu: state.hierarchicalMenu || {},
        });
    }, [uiState, selectedTabIndexName, selectedTabKey, typeFilterUrlKey]);
};
exports.useSyncUrlParams = useSyncUrlParams;
